// Entry point for the build script in your package.json
import {createConsumer} from "@rails/actioncable"
import hljs from "highlight.js/lib/core"
import json from 'highlight.js/lib/languages/json'
hljs.registerLanguage('json', json)

window.addEventListener("load", (event) => {
	hljs.highlightAll()

	if (Notification.permission !== "denied") {
		Notification.requestPermission()
	}

	const table = document.querySelector("table tbody")

	function cleanTable(table, max = 10) {
		const children = table.children
		const length = children.length
		if (length <= max) return
		for (let n = max; n < length; ++n) {
			const child = children.item(n)
			table.removeChild(child)
		}
	}


	if (table) {
		const endpoint = window.location.pathname.split('/', 2)[1]
		const consumer = createConsumer()
		consumer.subscriptions.create({channel: "ApplicationChannel", endpoint: endpoint}, {
			received(data) {
				console.info(data)
				// new Notification(`Webhook received for ${endpoint}`, {body: JSON.stringify(data, null, 2)})

				const tr = document.createElement("tr")
				for (const name of ["created_at", "method", "headers", "body"]) {
					const value = data[name]
					const td = document.createElement("td")
					if (name === "headers") {
						const headers = document.createElement("table")
						for (const [k, v] of Object.entries(value)) {
							const htr = document.createElement("tr")
							const hth = document.createElement("th")
							hth.textContent = k
							const htd = document.createElement("td")
							htd.textContent = v
							htr.append(hth, htd)
							headers.append(htr)
							td.append(headers)
						}
					} else if (name === "body") {
						const pre = document.createElement("pre")
						const code = document.createElement("code")
						code.textContent = JSON.stringify(JSON.parse(value), null, 2)
						pre.append(code)
						td.append(pre)
						hljs.highlightElement(pre)
					} else {
						td.textContent = value
					}
					tr.append(td)
				}
				table.prepend(tr)
				cleanTable(table)
			}
		})
	}
})
